import { booleanAttribute, Component, computed, input, model, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormValueControl } from '@angular/forms/signals';
import { MatIcon } from '@angular/material/icon';
import { debounce, distinctUntilChanged, Subject, timer } from 'rxjs';

@Component({
  selector: 'app-search-field',
  imports: [MatIcon],
  host: {
    class: 'search-field',
  },
  templateUrl: './search-field.component.html',
  styleUrl: './search-field.component.scss',
})
export class SearchFieldComponent implements FormValueControl<string | null> {
  value = model<string | null>('');

  placeholder = input('Search...');

  disabled = input(false, { transform: booleanAttribute });

  debounceTime = input(0);

  touched = input(false);

  touch = output<void>();

  debouncedValueChange = output<string>();

  private typed = new Subject<string>();

  protected text = computed(() => this.value() ?? '');

  constructor() {
    this.typed
      .pipe(
        debounce(() => timer(this.debounceTime())),
        distinctUntilChanged(),
        takeUntilDestroyed(),
      )
      .subscribe((value) => this.debouncedValueChange.emit(value));
  }

  protected onInput(event: Event) {
    if (!(event.target instanceof HTMLInputElement)) return;

    this.update(event.target.value);
  }

  protected clear(input: HTMLInputElement) {
    this.update('');
    input.focus();
  }

  private update(value: string) {
    this.value.set(value);
    this.typed.next(value);
  }
}
